/**
 * 帳款對象切成「個人」時,收執憑證 / 收款方式的預設值(REQ-20260810002)。
 *
 * 原本寫在 `CreateReceivableModal` 裡;REQ-20260811003 讓出貨管理的表單也能改帳款對象,
 * 兩邊必須套同一組預設 —— 這是業務規則(私帳不開公司發票、收現),不是畫面細節,
 * 複製一份會讓兩個入口建出來的私帳單長得不一樣。
 *
 * **比對名稱字串,不寫死 id** —— id 是各環境自己長出來的流水號。
 * 找不到符合的選項就不帶(欄位留空讓使用者自己選),不擋建單:
 * 這兩張設定表的內容是客戶自己維護的,沒有「個人」這筆並不是錯誤狀態。
 * 帶進去之後仍可手動改掉,不做成唯讀。
 */
export const PERSONAL_CERT_KEYWORDS = ['個人', '不開發票'];
export const PERSONAL_METHOD_KEYWORDS = ['現金', '個人'];

/** 第一個名稱含任一關鍵字的啟用中選項;都沒有就 null */
export function matchReferenceId(
  rows: { id: number; name: string; isActive: boolean }[] | undefined,
  keywords: string[],
): number | null {
  const hit = (rows ?? [])
    .filter((r) => r.isActive)
    .find((r) => keywords.some((k) => r.name.includes(k)));
  return hit?.id ?? null;
}
